import {Directive, ElementRef, HostListener, Input} from '@angular/core';

@Directive({
    selector: '[toggleClassOnHover]',
    standalone: false
})
export class ToggleClassOnHoverDirective {
    @Input('toggleClassOnHover') classes: string = "";

    constructor(private el: ElementRef) {}

    @HostListener('mouseover')
    onClick() {
        let classes = this.classes.split(" ");

        for (var i = 0; i < classes.length; i++) {
            this.el.nativeElement.classList.add(classes[i]);
        }
    }

    @HostListener('mouseleave')
    onMouseLeave() {
        let classes = this.classes.split(" ");

        for (var i = 0; i < classes.length; i++) {
            this.el.nativeElement.classList.remove(classes[i]);
        }
    }
}
